import { render } from "./App.vue?vue&type=template&id=0284bfbf&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\stack01.dev.irisdigital.ru\\.yarn\\__virtual__\\vue-loader-virtual-1066bd6fb6\\0\\cache\\vue-loader-npm-17.0.1-f552b82805-42cc8c8ff0.zip\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__